import React from "react"

// Master

export const RoleAccessPage = React.lazy(() => import("../Access/Role/Role"))

export const UserAccessPage = React.lazy(() =>
  import("../Access/UserAccess/UserAccess"),
)
export const MenuAccessPage = React.lazy(() => import("../Access/Menu/Menu"))

export const MenuAccessAccessPage = React.lazy(() =>
  import("../Access/MenuAccess/MenuAccess"),
)

export const UsersAccessPage = React.lazy(() => import("../Access/Users/Users"))
export const MenuRoleAccessPage = React.lazy(() =>
  import("../Access/RoleAccess/RoleAccess"),
)

export const LoketAntrianKunjunganPage = React.lazy(() =>
  import("../MasterData/LoketAntrianKunjungan/LoketAntrianKunjungan"),
)

export const AntrianLoketPage = React.lazy(() =>
  import("../MasterData/Antrian/Loket/Loket"),
)

export const LoketTextDisplayPage = React.lazy(() =>
  import("../MasterData/LoketTextDisplay/LoketTextDisplay"),
)
export const KunjunganTextDisplayPage = React.lazy(() =>
  import("../MasterData/KunjunganTextDisplay/KunjunganTextDisplay"),
)

export const GolonganDarahPage = React.lazy(() =>
  import("../MasterData/BloodType/BloodType"),
)

export const PendidikanPage = React.lazy(() =>
  import("../MasterData/Pendidikan/Pendidikan"),
)

export const SukuBangsaPage = React.lazy(() =>
  import("../MasterData/SukuBangsa/SukuBangsa"),
)
export const PenanggungJawabPage = React.lazy(() =>
  import("../MasterData/PenanggungJawab/PenanggungJawab"),
)
export const PekerjaanPage = React.lazy(() =>
  import("../MasterData/Pekerjaan/Pekerjaan"),
)
export const KasPage = React.lazy(() => import("../MasterData/Kas/Kas"))
export const TemaPage = React.lazy(() => import("../Tema/Tema"))

export const TipePembayaranPage = React.lazy(() =>
  import("../MasterData/TipePembayaran/TipePembayaran"),
)

export const KategoriSetting = React.lazy(() =>
  import("../MasterData/KategoriSetting/KategoriSetting"),
)

export const TarifPage = React.lazy(() => import("../MasterData/Tarif/Tarif"))

export const MovieListPage = React.lazy(() =>
  import("../Movie/MovieList/MovieList"),
)

export const MovieProfilingPage = React.lazy(() =>
  import("../Movie/MovieProfiling/MovieProfiling"),
)

export const JasaPage = React.lazy(() =>
  import("../MasterData/MasterPenjualan/Jasa/Jasa"),
)

export const PaketPage = React.lazy(() =>
  import("../MasterData/MasterPenjualan/Paket/Paket"),
)

export const TemplatePage = React.lazy(() =>
  import("../MasterData/MasterPenjualan/Template/Template"),
)

export const JenisJasaPage = React.lazy(() =>
  import("../MasterData/JenisJasa/JenisJasa"),
)

export const JenisFasilitasPage = React.lazy(() =>
  import("../MasterData/JenisFasilitas/JenisFasilitas"),
)

export const JenisRikjangPage = React.lazy(() =>
  import("../MasterData/JenisRikjang/JenisRikjang"),
)

export const JenisPaketPage = React.lazy(() =>
  import("../MasterData/JenisPaket/JenisPaket"),
)

export const MasterTag = React.lazy(() =>
  import("../MasterData/TagMaster/TagMaster"),
)

export const AutoBillingPage = React.lazy(() =>
  import("../../../../pages/Penjualan/Master/AutoBilling/AutoBilling"),
)

export const MasterGudangUtamaWMS = React.lazy(() =>
  import("../Wms/MasterWms/MasterGudangUtama/MasterGudangUtama"),
)

export const MasterSatuanWMS = React.lazy(() =>
  import("../Wms/MasterWms/MasterSatuan/MasterSatuan"),
)

export const MasterProdusenWMS = React.lazy(() =>
  import("../Wms/MasterWms/MasterProdusen/MasterProdusen"),
)

export const MasterSupplierWMS = React.lazy(() =>
  import("../Wms/MasterWms/MasterSupplier/MasterSupplier"),
)

export const MasterUnitWMS = React.lazy(() =>
  import("../Wms/MasterWms/MasterUnit/MasterUnit"),
)

export const MasterSupplier = React.lazy(() =>
  import("../Wms/MasterWms/MasterSupplier/MasterSupplier"),
)

export const MenuRoleAccess = React.lazy(() =>
  import("../Access/RoleAccess/RoleAccess"),
)

export const VerifikasiAccess = React.lazy(() =>
  import("../Access/VerifAccess/VerifikasiAccess"),
)

export const SettingSIMRS = React.lazy(() =>
  import("../Access/SettingSIMRS/SettingSIMRS"),
)

export const KonfigurasiPenjualan = React.lazy(() =>
  import("../Access/KonfigurasiPenjualan/KonfigurasiPenjualan"),
)

export const KonfigurasiRS = React.lazy(() =>
  import("../Access/KonfigurasiRS/KonfigurasiRS"),
)

export const DaftarNotifikasi = React.lazy(() =>
  import("../Access/DaftarNotifikasi/DaftarNotifikasi"),
)

// Registrasi

export const KunjunganRawatJalan = React.lazy(() =>
  import("../Registrasi/KunjunganRawatJalan/KunjunganRawatJalan"),
)

export const KunjunganRawatInap = React.lazy(() =>
  import("../Registrasi/KunjunganRawatInap/KunjunganRawatInap"),
)

export const KunjunganIgd = React.lazy(() =>
  import("../Registrasi/KunjunganIgd/KunjunganIgd"),
)

export const BookingAntrian = React.lazy(() =>
  import("../Registrasi/BookingAntrian/BookingAntrian"),
)

export const GabungRM = React.lazy(() =>
  import("../../../../pages/GabungRM/GabungRM"),
)

export const DaftarTagihan = React.lazy(() =>
  import("../Tagihan/DaftarTagihan/DaftarTagihan"),
)

export const InputTagihan = React.lazy(() =>
  import("../Tagihan/InputTagihan/InputTagihan"),
)

export const TagihanOtomatis = React.lazy(() =>
  import("../Tagihan/TagihanOtomatis/TagihanOtomatis"),
)

export const ServiceTutupTagihan = React.lazy(() =>
  import("../Tagihan/ServiceTutupTagihan/ServiceTutupTagihan"),
)

export const DaftarPembayaranTagihan = React.lazy(() =>
  import("../Tagihan/DaftarPembayaranTagihan/DaftarPembayaranTagihan"),
)

export const SaldoTagihan = React.lazy(() => import("../Tagihan/Saldo/Saldo"))

// PENJUALAN

export const DaftarPenjualan = React.lazy(() =>
  import("../Penjualan/DaftarPenjualan/DaftarPenjualan"),
)

export const InputPenjualan = React.lazy(() =>
  import("../Penjualan/InputPenjualan/InputPenjualan"),
)
export const ReturPenjualanPage = React.lazy(() =>
  import("../../../../pages/Penjualan/Transaksi/ReturPenjualan/ReturPenjualan"),
)

export const MasterRincianJasmedPage = React.lazy(() =>
  import("../../../../pages/JasaMedis/MasterRincianJasmed/MasterRincianJasmed"),
)

export const RekapJasmedPage = React.lazy(() =>
  import("../../../../pages/JasaMedis/RekapJasmed/RekapJasmed"),
)

export const DetailRekapJasmedPage = React.lazy(() =>
  import("../../../../pages/JasaMedis/DetailRekapJasmed/DetailRekapJasmed"),
)

export const MasterRikjang = React.lazy(() =>
  import("../../../../pages/Penjualan/Master/Rikjang/Rikjang"),
)

export const MasterFasilitas = React.lazy(() =>
  import("../../../../pages/Penjualan/Master/Fasilitas/Fasilitas"),
)

export const MasterHargaTarif = React.lazy(() =>
  import("../../../../pages/Penjualan/Master/HargaTarif/HargaTarif"),
)

export const UpdateHargaTarif = React.lazy(() =>
  import("../../../../pages/Penjualan/Master/UpdateHargaTarif/UpdateHargaTarif"),
)

export const ServiceTutupPenjualan = React.lazy(() =>
  import("../Penjualan/ServiceTutupPenjualan/ServiceTutupPenjualan"),
)

export const LaporanPenjualan = React.lazy(() =>
  import("../Penjualan/LaporanPenjualan/LaporanPenjualan"),
)

export const KasBonDokter = React.lazy(() =>
  import("../../../../pages/HRDokter/KasBonDokter/KasBonDokter"),
)

// Farmasi

export const WfMasterGudangPage = React.lazy(() =>
  import("../Wms/PerbekalanFarmasi/Master/MasterGudang/MasterGudang"),
)

export const WfMasterFormulaHargaPage = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/Master/MasterFormulaHarga/MasterFormulaHarga"
  ),
)

export const WfMasterTarifCbgPage = React.lazy(() =>
  import("../Wms/MasterWms/MasterTarifCbg/MasterTarifCbg"),
)

export const WfMasterBarangPage = React.lazy(() =>
  import("../Wms/PerbekalanFarmasi/Master/MasterBarang/MasterBarang"),
)

export const WfMasterKelasTerapiPage = React.lazy(() =>
  import("../Wms/PerbekalanFarmasi/Master/MasterKelasTerapi/MasterKelasTerapi"),
)
export const WfMasterGolonganObatPage = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/Master/MasterGolonganObat/MasterGolonganObat"
  ),
)

export const WfMasterFormulaPage = React.lazy(() =>
  import("../Wms/PerbekalanFarmasi/Master/MasterFormula/MasterFormula"),
)

export const WfMasterJenisHargaPage = React.lazy(() =>
  import("../Wms/PerbekalanFarmasi/Master/MasterHarga/MasterHarga"),
)

export const WfMasterJenisObatPage = React.lazy(() =>
  import("../Wms/PerbekalanFarmasi/Master/MasterJenisObat/MasterJenisObat"),
)

export const WfPurchaseOrderPage = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/TransaksiGudangUtama/PurchaseOrder/PurchaseOrder"
  ),
)

export const WfPembelianPage = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/TransaksiGudangUtama/PembelianWMS/PembelianWMS"
  ),
)

export const WfPembayaranPage = React.lazy(() =>
  import("../Wms/PerbekalanFarmasi/TransaksiGudangUtama/Pembayaran/Pembayaran"),
)

export const WfDaftarPembayaranPage = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/TransaksiGudangUtama/DaftarPembayaran/DaftarPembayaran"
  ),
)

export const WfDaftarPembelianPage = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/TransaksiGudangUtama/DaftarPembelian/DaftarPembelian"
  ),
)

export const WfDaftarPurchaseOrderPage = React.lazy(() =>
  import("../Wms/PerbekalanFarmasi/TransaksiGudangUtama/DaftarPo/DaftarPo"),
)

export const WfLaporanPembelianPage = React.lazy(() =>
  import(
    "../../../../pages/PerbekalanFarmasi/Laporan/LaporanPembelian/LaporanPembelian"
  ),
)

export const DaftarInventoryControl = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/InventoryControl/DaftarInventoryControl/DaftarInventoryControl"
  ),
)

export const DaftarMutasiItemPerbekalanFarmasi = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/InventoryControl/DaftarMutasiItem/DaftarMutasiItem"
  ),
)

export const MutasiItem = React.lazy(() =>
  import("../Wms/PerbekalanFarmasi/InventoryControl/MutasiItem/MutasiItem"),
)

export const ReturPembelianPerbekalanFarmasi = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/TransaksiGudangUtama/ReturPembelian/ReturPembelian"
  ),
)

export const TrackingNarkotik = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/InventoryControl/TrackingNarkotik/TrackingNarkotik"
  ),
)

export const InputRequestMutasi = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/InventoryControl/InputRequestMutasi/InputRequestMutasi"
  ),
)

export const InputReceiveMutasi = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/InventoryControl/InputReceiveMutasi/InputReceiveMutasi"
  ),
)

export const LaporanNarkotik = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/LaporanPerbekalanFarmasi/LaporanNarkotik/LaporanNarkotik"
  ),
)

export const HistoryStokFarmasi = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/LaporanPerbekalanFarmasi/HistoryStok/HistoryStok"
  ),
)

export const KartuStokFarmasi = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/LaporanPerbekalanFarmasi/KartuStok/KartuStok"
  ),
)

export const ForecastingFarmasi = React.lazy(() =>
  import("../../../../pages/Laporan/LaporanForecasting/LaporanForecasting"),
)

export const ServiceTutupPembelian = React.lazy(() =>
  import(
    "../Wms/PerbekalanFarmasi/TransaksiGudangUtama/ServiceTutupPembelian/ServiceTutupPembelian"
  ),
)

// AKUTANSI

export const AkutansiJurnalUmumPage = React.lazy(() =>
  import("../../../../pages/Akuntansi/Transaksi/JurnalUmum/JurnalUmum"),
)

export const AkutansiDaftarJurnalPage = React.lazy(() =>
  import("../../../../pages/Akuntansi/Transaksi/DaftarJurnal/DaftarJurnal"),
)

export const AkutansiNeracaSaldoPage = React.lazy(() =>
  import("../../../../pages/Akuntansi/Transaksi/NeracaSaldo/NeracaSaldo"),
)

export const AkutansiBukuBesarPage = React.lazy(() =>
  import("../../../../pages/Akuntansi/Transaksi/BukuBesar/BukuBesar"),
)

export const AkutansiLabaRugiPage = React.lazy(() =>
  import("../../../../pages/Akuntansi/Transaksi/LabaRugi/LabaRugi"),
)

export const AkutansiLabaRugiDetailPage = React.lazy(() =>
  import("../../../../pages/Akuntansi/Transaksi/LabaRugiDetail/LabaRugiDetail"),
)

export const AkutansiNeracaBulanPage = React.lazy(() =>
  import("../../../../pages/Akuntansi/Transaksi/Neraca/NeracaBulan"),
)

export const AkutansiNeracaBulanDetailPage = React.lazy(() =>
  import(
    "../../../../pages/Akuntansi/Transaksi/NeracaSaldoDetail/NeracaBulanDetail"
  ),
)

export const AkutansiLaporanNeracaPage = React.lazy(() =>
  import("../../../../pages/Akuntansi/Laporan/LaporanNeraca/LaporanNeraca"),
)

export const AkutansiLaporanLabaRugiPage = React.lazy(() =>
  import("../../../../pages/Akuntansi/Laporan/LaporanLabaRugi/LaporanLabaRugi"),
)

export const AkutansiLaporanLabaRugiV2Page = React.lazy(() =>
  import(
    "../../../../pages/Akuntansi/Laporan/LaporanLabaRugiV2/LaporanLabaRugiV2"
  ),
)

export const AkutansiLaporanNeracaV2Page = React.lazy(() =>
  import("../../../../pages/Akuntansi/Laporan/LaporanNeracaV2/LaporanNeracaV2"),
)

export const AkutansiLaporanRekapNeracaV2Page = React.lazy(() =>
  import(
    "../../../../pages/Akuntansi/Laporan/LaporanRekapNeraca/LaporanRekapNeraca"
  ),
)

export const AkutansiLaporanRekapLabaRugiV2Page = React.lazy(() =>
  import(
    "../../../../pages/Akuntansi/Laporan/LaporanRekapLabaRugi/LaporanRekapLabaRugi"
  ),
)

export const AkutansiLaporanCashFlowPage = React.lazy(() =>
  import("../../../../pages/Akuntansi/Laporan/LaporanCashFlow/LaporanCashFlow"),
)

export const AkutansiSynchronize = React.lazy(() =>
  import("../../../../pages/Akuntansi/Transaksi/Synchronize/Synchronize"),
)

export const AkutansiTipePenerimaPage = React.lazy(() =>
  import("../../../../pages/Akuntansi/Master/TipePenerima/TipePenerima"),
)

export const AkutansiTipeGLPage = React.lazy(() =>
  import("../../../../pages/Akuntansi/Master/TipeGL/TipeGL"),
)

export const AkutansiPeriode = React.lazy(() =>
  import("../../../../pages/Akuntansi/Master/Periode/Periode"),
)

export const AkutansiTargetPendapatan = React.lazy(() =>
  import(
    "../../../../pages/Akuntansi/Master/TargetPendapatan/TargetPendapatan"
  ),
)

export const AkutansiSaldoAwal = React.lazy(() =>
  import("../../../../pages/Akuntansi/Master/SaldoAwal/SaldoAwal"),
)

export const AkutansiSettingNeraca = React.lazy(() =>
  import("../../../../pages/Akuntansi/Master/SettingNeraca/SettingNeraca"),
)

export const AkutansiSettingLabaRugi = React.lazy(() =>
  import("../../../../pages/Akuntansi/Master/SettingLabarugi/SettingLabaRugi"),
)

export const AkutansiSettingCashFlow = React.lazy(() =>
  import("../../../../pages/Akuntansi/Master/SettingCashFlow/SettingCashFlow"),
)

export const AkutansiJurnalPenutup = React.lazy(() =>
  import("../../../../pages/Akuntansi/Transaksi/JurnalPenutup/JurnalPenutup"),
)

export const MasterCOA = React.lazy(() => import("../Akuntansi/Master/Coa/Coa"))

export const SettingDashboardPage = React.lazy(() =>
  import("../../../../pages/Dashboard/SettingDashboard/SettingDashboard"),
)

export const Dashboard = React.lazy(() =>
  import("../../../../pages/Dashboard/Dashboard/Dashboard"),
)

// END AKUTANSI

// MOBILE MANAGEMENT
export const MobileMemberList = React.lazy(() =>
  import("../../../../pages/MobileManagement/Member/Member"),
)

//MOBILE
export const Faq = React.lazy(() => import("../Manajemen/Mobile/FAQ/Faq"))

export const Slider = React.lazy(() =>
  import("../Manajemen/Mobile/Slider/Slider"),
)

export const JadwalDokterTelekonsul = React.lazy(() =>
  import(
    "../../../../pages/Dokter/JadwalDokterTelekonsul/JadwalDokterTelekonsul"
  ),
)

export const TarifDokterTelekonsul = React.lazy(() =>
  import(
    "../../../../pages/Dokter/TarifDokterTelekonsul/TarifDokterTelekonsul"
  ),
)

export const PembelianTelekonsul = React.lazy(() =>
  import(
    "../../../../pages/Telekonsul/PembelianTelekonsul/PembelianTelekonsul"
  ),
)

export const PembayaranTelekonsul = React.lazy(() =>
  import(
    "../../../../pages/Telekonsul/PembayaranTelekonsul/PembayaranTelekonsul"
  ),
)

// export const DaftarPaketTelekonsul = React.lazy(() =>
//   import(
//     "../../../../pages/Telekonsul/PaketTelekonsul/DaftarPaketTelekonsul/DaftarPaketTelekonsul"
//   )
// );

// END MOBILE MANAGEMENT

// LAPORAN

export const LaporanAntrianJKNPage = React.lazy(() =>
  import("../../../../pages/Laporan/LaporanAntrianJKN/LaporanAntrianJKN"),
)

export const LaporanJadwalDokterPage = React.lazy(() =>
  import("../../../../pages/Laporan/LaporanJadwalDokter/LaporanJadwalDokter"),
)

export const LaporanJadwalOperasiPage = React.lazy(() =>
  import("../../../../pages/Laporan/LaporanJadwalOperasi/LaporanJadwalOperasi"),
)

export const LaporanJasaMedisPage = React.lazy(() =>
  import("../../../../pages/Laporan/LaporanJasaMedis/LaporanJasaMedis"),
)

// END LAPORAN

// Dokter
export const PerubahanJadwalDokterPage = React.lazy(() =>
  import(
    "../../../../pages/Dokter/PerubahanJadwalDokter/PerubahanJadwalDokter"
  ),
)
// END LAPORAN

// MASTER

export const Agama = React.lazy(() => import("../MasterData/Agama/Agama"))

export const Lokasi = React.lazy(() =>
  import("../../../../pages/SatuSehat/Lokasi/Lokasi"),
)

export const Organisasi = React.lazy(() =>
  import("../../../../pages/SatuSehat/Organisasi/Organisasi"),
)

export const Bundle = React.lazy(() =>
  import("../../../../pages/SatuSehat/Bundle/Bundle"),
)

export const Counter = React.lazy(() =>
  import("../../../../pages/SatuSehat/Counter/Counter"),
)

export const Encounter = React.lazy(() =>
  import("../../../../pages/SatuSehat/Encounter/Encounter"),
)

export const KFA = React.lazy(() =>
  import("../../../../pages/SatuSehat/KFA/KFA"),
)

export const KYC = React.lazy(() =>
  import(
    "../../../../pages/SatuSehat/VerifikasiSatuSehatKYC/VerifikasiSatuSehatKYC"
  ),
)

export const Bank = React.lazy(() => import("../MasterData/Bank/Bank"))
export const Qualification = React.lazy(() =>
  import("../MasterData/Qualification/Qualification"),
)
export const Hospital = React.lazy(() =>
  import("../MasterData/Hospital/Hospital"),
)
export const Spesialis = React.lazy(() =>
  import("../MasterData/Spesialis/Spesialis"),
)
export const TipeRegistrasi = React.lazy(() =>
  import("../MasterData/TipeRegistrasi/TipeRegistrasi"),
)
export const KelasKunjungan = React.lazy(() =>
  import("../MasterData/KelasKunjungan/KelasKunjungan"),
)
export const Poliklinik = React.lazy(() =>
  import("../MasterData/Poliklinik/Poliklinik"),
)
export const PoliklinikSpesialis = React.lazy(() =>
  import("../MasterData/PoliklinikSpesialis/PoliklinikSpesialis"),
)
export const Layanan = React.lazy(() => import("../MasterData/Layanan/Layanan"))
export const LayananRuang = React.lazy(() =>
  import("../MasterData/LayananRuang/LayananRuang"),
)
export const JenisLayanan = React.lazy(() =>
  import("../MasterData/JenisLayanan/JenisLayanan"),
)
export const JenisRawat = React.lazy(() =>
  import("../MasterData/JenisRawat/JenisRawat"),
)
export const JenisAsuransi = React.lazy(() =>
  import("../MasterData/JenisAsuransi/JenisAsuransi"),
)
export const JenisHarga = React.lazy(() =>
  import("../MasterData/JenisHarga/JenisHarga"),
)
export const Formula = React.lazy(() => import("../MasterData/Formula/Formula"))
export const Bed = React.lazy(() => import("../MasterData/Bed/Bed"))

// Rekap Tagihan
export const InputRekapTagihan = React.lazy(() =>
  import("../RekapTagihan/InputRekapTagihan/InputRekapTagihan"),
)
export const DaftarRekapTagihan = React.lazy(() =>
  import("../RekapTagihan/DaftarRekapTagihan/DaftarRekapTagihan"),
)
export const AggingPiutangRekap = React.lazy(() =>
  import("../RekapTagihan/AggingPiutangRekap/AggingPiutangRekap"),
)

export const DaftarPembayaranRekap = React.lazy(() =>
  import("../RekapTagihan/DaftarPembayaranRekap/DaftarPembayaranRekap"),
)

// Logistik
export const MasterGudangLogistik = React.lazy(() =>
  import("../Wms/Logistik/Master/MasterGudang/MasterGudang"),
)
export const MasterGolonganBarangLogistik = React.lazy(() =>
  import("../Wms/Logistik/Master/MasterGolonganBarang/MasterGolonganBarang"),
)
export const MasterJenisBarangLogistik = React.lazy(() =>
  import("../Wms/Logistik/Master/MasterJenisBarang/MasterJenisBarang"),
)
export const StatusPengeluaranBarangLogistik = React.lazy(() =>
  import(
    "../Wms/Logistik/Master/StatusPengeluaranBarang/StatusPengeluaranBarang"
  ),
)
export const MasterBarangLogistik = React.lazy(() =>
  import("../Wms/Logistik/Master/MasterBarang/MasterBarang"),
)
export const ReturPembelianLogistik = React.lazy(() =>
  import("../Wms/Logistik/TransaksiGudangUtama/ReturPembelian/ReturPembelian"),
)
export const InputRequestMutasiLogistik = React.lazy(() =>
  import(
    "../Wms/Logistik/InventoryControl/InputRequestMutasi/InputRequestMutasi"
  ),
)
export const DaftarMutasiItemLogistik = React.lazy(() =>
  import("../Wms/Logistik/InventoryControl/DaftarMutasiItem/DaftarMutasiItem"),
)
export const InputReceiveMutasiLogistik = React.lazy(() =>
  import(
    "../Wms/Logistik/InventoryControl/InputReceiveMutasi/InputReceiveMutasi"
  ),
)
export const MutasiItemLogistik = React.lazy(() =>
  import("../Wms/Logistik/InventoryControl/MutasiItem/MutasiItem"),
)
export const DaftarInventoryControlLogistik = React.lazy(() =>
  import(
    "../Wms/Logistik/InventoryControl/DaftarInventoryControl/DaftarInventoryControl"
  ),
)

export const ServiceTutupPembelianLogistik = React.lazy(() =>
  import(
    "../Wms/Logistik/TransaksiGudangUtama/ServiceTutupPembelian/ServiceTutupPembelian"
  ),
)
export const HistoryStokLogistik = React.lazy(() =>
  import("../Wms/Logistik/LaporanLogistik/HistoryStok/HistoryStok"),
)
export const KartuStokLogistik = React.lazy(() =>
  import("../Wms/Logistik/LaporanLogistik/KartuStok/KartuStok"),
)
export const LaporanStokLogistik = React.lazy(() =>
  import("../Wms/Logistik/LaporanLogistik/LaporanStok/LaporanStok"),
)

// Fixed Asset
export const DepreciationMethodFixedAsset = React.lazy(() =>
  import("../FixedAsset/Atribut/DepreciationMethod/DepreciationMethod"),
)

export const TipeFiscalFixedAsset = React.lazy(() =>
  import("../FixedAsset/Atribut/TipeFiscal/TipeFiscal"),
)

export const TipeAssetFixedAsset = React.lazy(() =>
  import("../FixedAsset/Atribut/TipeAsset/TipeAsset"),
)

export const TingkatAssetFixedAsset = React.lazy(() =>
  import("../FixedAsset/Atribut/TingkatAsset/TingkatAsset"),
)

export const MasterVendorFixedAsset = React.lazy(() =>
  import("../FixedAsset/Master/MasterVendor/Vendor"),
)

export const MasterGudangFixedAsset = React.lazy(() =>
  import("../FixedAsset/Master/MasterGudang/MasterGudang"),
)

export const MasterTipeNotifikasi = React.lazy(() =>
  import("../FixedAsset/Master/MasterTipeNotifikasi/TipeNotifikasi"),
)

export const MasterGolonganBarangFixedAsset = React.lazy(() =>
  import("../FixedAsset/Master/MasterGolonganBarang/MasterGolonganBarang"),
)

export const ManajemenNotifikasiFixedAsset = React.lazy(() =>
  import("../FixedAsset/Transaksi/ManajemenNotifikasi/ManajemenNotifikasi"),
)

export const DisposeAssetFixedAsset = React.lazy(() =>
  import("../FixedAsset/Transaksi/DisposeAsset/DisposeAsset"),
)

export const DaftarNotifikasiAssetFixedAsset = React.lazy(() =>
  import("../FixedAsset/Transaksi/DaftarNotifikasiAsset/DaftarNotifikasiAsset"),
)

export const KalibrasiAssetFixedAsset = React.lazy(() =>
  import("../FixedAsset/Transaksi/Kalibrasi/Kalibrasi"),
)

// Management
export const ManajemenBed = React.lazy(() => import("../Manajemen/Bed/Bed"))

export const ManajemenDokter = React.lazy(() =>
  import("../Manajemen/Dokter/Dokter"),
)

export const ManajemenJadwalDokter = React.lazy(() =>
  import("../Manajemen/JadwalDokter/JadwalDokter"),
)

export const ManajemenKuotaOnline = React.lazy(() =>
  import("../Manajemen/KuotaOnline/KuotaOnline"),
)

export const VerifikasiBooking = React.lazy(() =>
  import("../VerifikasiBooking/VerifikasiBooking"),
)

// Laporan Service
export const LaporanService = React.lazy(() =>
  import("../Laporan/LaporanService/LaporanService"),
)

export const StatusService = React.lazy(() =>
  import("../Laporan/StatusService/StatusService"),
)

export const LaporanIncome = React.lazy(() =>
  import("../Laporan/LaporanIncome/LaporanIncome"),
)

export const LaporanRegistrasi = React.lazy(() =>
  import("../Laporan/LaporanRegistrasi/LaporanRegistrasi"),
)

export const LaporanLogBridging = React.lazy(() =>
  import("../Laporan/LaporanLogBridging/LaporanLogBridging"),
)

// Antrian

export const AntrianDisplay = React.lazy(() =>
  import("../ManajemenAntrian/AntrianDisplay/AntrianDisplay"),
)

export const QueueAntrian = React.lazy(() =>
  import("../ManajemenAntrian/QueueAntrian/QueueAntrian"),
)

export const LoketCallAntrian = React.lazy(() =>
  import("../LoketCall/LoketCall"),
)

export const PoliCall = React.lazy(() => import("../PoliCall/PoliCall"))

export const LayananCall = React.lazy(() => import("../LayananCall/PoliCall"))

export const KasirCall = React.lazy(() => import("../KasirCall/PoliCall"))

export const FarmasiCall = React.lazy(() => import("../FarmasiCall/PoliCall"))

export const ProfileRekamMedis = React.lazy(() =>
  import("../Registrasi/ProfileRekamMedis/ProfileRekamMedis"),
)

// BPJS
export const InputEklaim = React.lazy(() =>
  import("../Eklaim/InputEklaim/InputEklaim"),
)

export const DaftarTagihanBPJS = React.lazy(() =>
  import("../Tagihan/DaftarTagihanBPJS/DaftarTagihanBPJS"),
)

export const Purifikasi = React.lazy(() =>
  import("../Tagihan/Purifikasi/Purifikasi"),
)

export const UploadManual = React.lazy(() =>
  import("../Tagihan/Rekonsil/UploadManual/UploadManual"),
)
export const Rekonsiliasi = React.lazy(() =>
  import("../Tagihan/Rekonsil/Rekonsilliasi/Rekonsilliasi"),
)
export const KonfigurasiRekonsil = React.lazy(() =>
  import("../Tagihan/Rekonsil/KonfigurasiRekonsil/KonfigurasiFileRekonsil"),
)
export const RekonsiliasiBPJS = React.lazy(() =>
  import("../Tagihan/Rekonsil/RekonsilliasiBPJS/RekonsilliasiBPJS"),
)

export const UploadManualKronis = React.lazy(() =>
  import("../Tagihan/RekonsilKronis/UploadManualKronis/UploadManualKronis"),
)
export const RekonsiliasiKronis = React.lazy(() =>
  import("../Tagihan/RekonsilKronis/RekonsilliasiKronis/RekonsilliasiKronis"),
)
export const KonfigurasiFileRekonsil = React.lazy(() =>
  import(
    "../Tagihan/RekonsilKronis/KonfigurasiFileRekonsil/KonfigurasiFileRekonsil"
  ),
)

export const AdministratifBPJS = React.lazy(() =>
  import("../../../../pages/BPJS/Vclaim/Administratif/Administratif"),
)
export const BPJSVclaim = React.lazy(() =>
  import("../../../../pages/BPJS/Vclaim/Vclaim"),
)
export const BPJSVclaimPengajuanSep = React.lazy(() =>
  import("../../../../pages/BPJS/Vclaim/PengajuanSep/PortalSep"),
)
export const BPJSVclaimApprovalSep = React.lazy(() =>
  import("../../../../pages/BPJS/Vclaim/ApprovalSep/ApprovalSep"),
)
export const BPJSVclaimUpdateTanggalPulang = React.lazy(() =>
  import("../../../../pages/BPJS/Vclaim/PengajuanSep/PortalUpdate"),
)
export const BPJSVclaimRujukan = React.lazy(() =>
  import("../../../../pages/BPJS/Vclaim/Rujukan/Rujukan"),
)
export const BPJSVclaimRujukanKhusus = React.lazy(() =>
  import("../../../../pages/BPJS/Vclaim/RujukanKhusus/RujukanKhusus"),
)
export const BPJSVclaimSep = React.lazy(() =>
  import("../../../../pages/BPJS/Vclaim/Sep/Sep"),
)
export const BPJSVclaimPrb = React.lazy(() =>
  import("../../../../pages/BPJS/Vclaim/Prb/Prb"),
)
export const WSBPJS = React.lazy(() =>
  import("../../../../pages/BPJS/WsBPJS/WsBPJS"),
)
export const WSBPJSAntrean = React.lazy(() =>
  import("../../../../pages/BPJS/WsBPJS/RefAntrean/RefAntrean"),
)
export const WSBPJSDasboardWaktuTunggu = React.lazy(() =>
  import("../../../../pages/BPJS/WsBPJS/RefDashboardWaktuTunggu/WaktuTunggu"),
)
export const WSBPJSRefPoliFingerPrint = React.lazy(() =>
  import("../../../../pages/BPJS/WsBPJS/RefPoliFP/RefPoliFP"),
)
export const WSBPJSRefPasienFingerPrint = React.lazy(() =>
  import("../../../../pages/BPJS/WsBPJS/RefPasienFP/RefPasienFP"),
)
export const WSBPJSTaskId = React.lazy(() =>
  import("../../../../pages/BPJS/WsBPJS/ListTaskId/ListTask"),
)
export const BPJSApotek = React.lazy(() =>
  import("../../../../pages/BPJS/Apotek/Apotek"),
)
export const MultipelTabVclaim = React.lazy(() =>
  import("../../../../pages/BPJS/Vclaim/MultiTab/MultiTab"),
)
export const MultipelTabApotek = React.lazy(() =>
  import("../../../../pages/BPJS/Apotek/MultiTab/MultiTab"),
)
export const FaskesVclaim = React.lazy(() =>
  import("../../../../pages/BPJS/Vclaim/Faskes/Faskes"),
)
export const DpjpVclaim = React.lazy(() =>
  import("../../../../pages/BPJS/Vclaim/Dpjp/Dpjp"),
)

export const RingkasanPasienPulangRawatJalan = React.lazy(() =>
  import(
    "../../../../pages/Casemix/RingkasanPasienPulang/RawatJalan/RawatJalan"
  ),
)

export const RingkasanPasienPulangHemodialisa = React.lazy(() =>
  import(
    "../../../../pages/Casemix/RingkasanPasienPulang/Hemodialisa/Hemodialisa"
  ),
)

export const RingkasanPasienPulangRawatInap = React.lazy(() =>
  import("../../../../pages/Casemix/RingkasanPasienPulang/RawatInap/RawatInap"),
)

export const RingkasanPasienPulangIGD = React.lazy(() =>
  import("../../../../pages/Casemix/RingkasanPasienPulang/IGD/IGD"),
)

export const LaporanOperasi = React.lazy(() =>
  import(
    "../../../../pages/Casemix/RingkasanPasienPulang/LaporanOperasi/LaporanOperasi"
  ),
)

export const Fisioterapi = React.lazy(() =>
  import(
    "../../../../pages/Casemix/RingkasanPasienPulang/Fisioterapi/Fisioterapi"
  ),
)

export const LaporanTindakan = React.lazy(() =>
  import(
    "../../../../pages/Casemix/RingkasanPasienPulang/LaporanTindakan/LaporanTindakan"
  ),
)

export const DigitalSign = React.lazy(() =>
  import("../../../../pages/Casemix/DigitalSign/DigitalSign"),
)

export const MappingRikjangProsedur = React.lazy(() =>
  import("../../../../pages/Casemix/RikjangProsedur/RikjangProsedur"),
)

// WS BRIDGING BPJS
export const DataDokter = React.lazy(() =>
  import("../../../../pages/WsBridging/RencanaKontrol/Dokter/Dokter"),
)

export const CariSep = React.lazy(() =>
  import("../../../../pages/WsBridging/RencanaKontrol/Sep/Sep"),
)

export const DataKlaim = React.lazy(() =>
  import("../../../../pages/WsBridging/Monitoring/Klaim/Klaim"),
)

export const DataKunjungan = React.lazy(() =>
  import("../../../../pages/WsBridging/Monitoring/Kunjungan/Kunjungan"),
)

export const DataPelayanan = React.lazy(() =>
  import("../../../../pages/WsBridging/Monitoring/Pelayanan/Pelayanan"),
)

export const DataJaminan = React.lazy(() =>
  import("../../../../pages/WsBridging/Monitoring/Jaminan/Jaminan"),
)

export const DataBpjs = React.lazy(() =>
  import("../../../../pages/WsBridging/Peserta/Bpjs/Bpjs"),
)

export const DataNik = React.lazy(() =>
  import("../../../../pages/WsBridging/Peserta/Nik/Nik"),
)

export const DataSep = React.lazy(() =>
  import("../../../../pages/WsBridging/Sep/Sep/Sep"),
)

export const DataMultiRecordPCare = React.lazy(() =>
  import("../../../../pages/WsBridging/Rujukan/MultiRecord/PCare/PCare"),
)

export const DataSarana = React.lazy(() =>
  import("../../../../pages/WsBridging/Rujukan/Sarana/Sarana"),
)

export const DataKeluarRs = React.lazy(() =>
  import("../../../../pages/WsBridging/Rujukan/KeluarRs/KeluarRs"),
)
